<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M22.9033 19.8047V21.8623H2.09473V19.8047H22.9033ZM19.7783 10.4297V17.6963H17.7197V10.4297H19.7783ZM13.5283 10.4297V17.6963H11.4697V10.4297H13.5283ZM7.27832 10.4297V17.6963H5.21973V10.4297H7.27832ZM22.9033 6.25781V8.32129H2.09473V6.25781L12.498 1.05469L22.9033 6.25781ZM12.4932 3.37402L6.71191 6.23926L6.71777 6.2627H18.2803L18.2852 6.23926L12.5039 3.37402L12.5078 3.36719L12.4932 3.37402Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.025"
    />
  </svg>
</template>
